import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

export default function withTracking(reactPlugin: ReactPlugin, Component: React.ComponentType, componentName?: string, className?: string): any {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        return Component;
    }
    return withAITracking(reactPlugin, Component, componentName, className);
}